<template>
  <b-overlay
  rounded="sm"
  spinner-variant="success"
  spinner-type="grow"
  >

          <div class="relative">
<!--            <div class="period-label mt-4 font-poppins">-->
<!--              {{ $cte('flatRate.informText') }}-->
<!--            </div>-->
              <div class="_card-body desktop-limits">
                <div class="d-flex flex-row align-items-center align-items-stretch mt-3 reportSliderContainer" >
                  <div class="paging-div mr-4"  @click="pageLeft">
                      <i class="fas fa-angle-left"></i>
                  </div>
                <div class="mt-4 relative container-style">
                  <div class="d-flex justify-content-center spacing mb-4">
                    <div class="title" >{{yearPointer}}</div>
                  </div>
                  <div>
                    <!--    FLAT RATE CAP-->
                    <div class="px-5 my-4" v-if="loaded && hasFlatRateTaxLimit">
                      <div class="font-weight-bold d-flex justify-content-start">
                        <div>{{ $cte("flatRate.flatRateCap") }}</div>
                        <div class="ml-2">
                          {{ Number(data58.flatRateTaxLimit).toLocaleString("hu-HU") }} Ft
                        </div>
                      </div>
                      <div class="w-100 position-relative height-0">
                        <div
                          class="w-100 d-flex justify-content-between p-1 position-relative font-weight-bold"

                        >
                          <div>
                            {{
                              $cte("flatRate.limitUsed") +
                              Number(data58.flatRateTaxUsed).toLocaleString("hu-HU")
                            }}
                          </div>
                          <div>
                            {{
                              $cte("flatRate.limitAvailable") +
                              Number(
                                data58.flatRateTaxLimit - data58.flatRateTaxUsed
                              ).toLocaleString("hu-HU")
                            }}
                          </div>
                        </div>
                      </div>
                      <div class="progress">
                        <div
                          class="progress-bar"
                          role="progressbar"
                          :style="{ width: (data58.flatRateTaxUsed / data58.flatRateTaxLimit) * 100 + '%' }"
                        ></div>
                      </div>
                    </div>
                    <!--    END OF FLAT RATE CAP-->
                
                    <!--    AAM CAP-->
                    <div class="px-5 my-4" v-if="loaded && !getActiveCompany.materialTaxFree && !aamCapIsHiddenData">
                      <div class="font-weight-bold d-flex justify-content-start">
                        <div>{{ $cte("flatRate.aamCap") }}</div>
                        <div class="ml-2">{{ Number(data58.aamLimit).toLocaleString("hu-HU") }} Ft</div>
                      </div>
                      <div class="w-100 position-relative height-0">
                        <div
                          class="w-100 d-flex justify-content-between p-1 position-relative font-weight-bold"
                        >
                          <div>
                            {{
                              $cte("flatRate.limitUsed") +
                              Number(data58.aamUsed).toLocaleString("hu-HU")
                            }}
                          </div>
                          <div>
                            {{
                              $cte("flatRate.limitAvailable") +
                              Number(
                                data58.aamLimit - data58.aamUsed
                              ).toLocaleString("hu-HU")
                            }}
                          </div>
                        </div>
                      </div>
                      <div class="progress">
                        <div
                          class="progress-bar"
                          role="progressbar"
                          :style="{ width: (data58.aamUsed / data58.aamLimit) * 100 + '%' }"
                        ></div>
                      </div>
                    </div>
                    <!--    END OF AAM CAP-->

                    <!--    CASH FLOW BASED VAT LIMIT-->
                    <div class="px-5 my-4" v-if="loaded && hasCashFlowBasedVatLimit">
                      <div class="font-weight-bold d-flex justify-content-start">
                        <div>Pénzforgalmi ÁFA kereted</div>
                        <div class="ml-2">{{ Number(cashFlowBasedVatLimit.limit).toLocaleString("hu-HU") }} Ft</div>
                      </div>
                      <div class="w-100 position-relative height-0">
                        <div
                          class="w-100 d-flex justify-content-between p-1 position-relative font-weight-bold"
                        >
                          <div>
                            {{
                              $cte("flatRate.limitUsed") +
                              Number(cashFlowBasedVatLimit.used).toLocaleString("hu-HU")
                            }}
                          </div>
                          <div>
                            {{
                              $cte("flatRate.limitAvailable") +
                              Number(
                                cashFlowBasedVatLimit.limit - cashFlowBasedVatLimit.used
                              ).toLocaleString("hu-HU")
                            }}
                          </div>
                        </div>
                      </div>
                      <div class="progress">
                        <div
                          class="progress-bar"
                          role="progressbar"
                          :style="{ width: cashFlowBasedVatLimitProgress + '%' }"
                        ></div>
                      </div>
                    </div>
                    <!--    END OF CASH FLOW BASED VAT LIMIT-->
                 
                  </div>
                </div>
                <div
                  class="paging-div ml-4"
                  @click="pageRight"
                >
                  <i class="fas fa-angle-right"></i>
                </div>
            </div>
    
            
              </div>
              <div class="mobile-limits">
                <div class="d-flex flex-row align-items-center align-items-stretch spacing-2 card-container" >
                  <div class="paging-div mr-4"  @click="pageLeft">
                    <i class="fas fa-angle-left"></i>
                  </div>
                  <div class="mt-4 relative container-style">
                    <div class="d-flex justify-content-center spacing mb-4">
                      <div class="title" >{{yearPointer}}</div>
                    </div>
                  </div>
                  <div
                  class="paging-div ml-4"
                  @click="pageRight"
                  >
                    <i class="fas fa-angle-right"></i>
                  </div>
                </div>
                
                <div class="d-flex flex-column spacing-4 align-items-center">
                    <div class="w-100" v-if="loaded && hasFlatRateTaxLimit">
                      <div class="mobile-title text-left">Átalányadó Keret</div>
                      <div class="mobile-limit-list-item d-flex flex-row justify-content-between">
                        <div>Kereted: </div>
                        <div>{{ Number(data58.flatRateTaxLimit).toLocaleString("hu-HU")}} Ft</div>
                      </div>
                      <div class="mobile-limit-list-item d-flex flex-row justify-content-between">
                        <div>Hátravan: </div>
                        <div>
                          {{ Number(data58.flatRateTaxLimit - data58.flatRateTaxUsed).toLocaleString("hu-HU")}} Ft
                        </div>
                      </div>
                      <div class="mobile-limit-list-item d-flex flex-row justify-content-between">
                        <div>Felhasznált: </div>
                        <div>{{ Number(data58.flatRateTaxUsed).toLocaleString("hu-HU") }}  Ft</div>
                      </div>
                      <div class="mobile-limit-list-item d-flex flex-row justify-content-between">
                        <div>Felhasznált: </div>
                        <div>{{ parseInt( (data58.flatRateTaxUsed / data58.aamLimit) * 100) }} % </div>
                      </div>
                    </div>
                    <div class="w-100 mt-5" v-if="loaded && !getActiveCompany.materialTaxFree && !aamCapIsHiddenData">
                      <div class="mobile-title text-left">AAM Keret</div>
                      <div class="mobile-limit-list-item d-flex flex-row justify-content-between">
                        <div>Kereted: </div>
                        <div>{{ Number(data58.aamUsed).toLocaleString("hu-HU")}} Ft</div>
                      </div>
                      <div class="mobile-limit-list-item d-flex flex-row justify-content-between">
                        <div>Hátravan: </div>
                        <div>
                          {{ Number(data58.aamLimit - data58.aamUsed).toLocaleString("hu-HU")}} Ft
                        </div>
                      </div>
                      <div class="mobile-limit-list-item d-flex flex-row justify-content-between">
                        <div>Felhasznált: </div>
                        <div>{{ Number(data58.aamUsed).toLocaleString("hu-HU") }}  Ft</div>
                      </div>
                      <div class="mobile-limit-list-item d-flex flex-row justify-content-between">
                        <div>Felhasznált: </div>
                        <div>{{ parseInt( (data58.aamUsed / data58.aamLimit) * 100) }} % </div>
                      </div>
                    </div>
                    <div class="w-100 mt-5" v-if="loaded && hasCashFlowBasedVatLimit">
                      <div class="mobile-title text-left">Pénzforgalmi ÁFA kereted</div>
                      <div class="mobile-limit-list-item d-flex flex-row justify-content-between">
                        <div>Kereted: </div>
                        <div>{{ Number(cashFlowBasedVatLimit.limit).toLocaleString("hu-HU")}} Ft</div>
                      </div>
                      <div class="mobile-limit-list-item d-flex flex-row justify-content-between">
                        <div>Hátravan: </div>
                        <div>
                          {{ Number(cashFlowBasedVatLimit.limit - cashFlowBasedVatLimit.used).toLocaleString("hu-HU")}} Ft
                        </div>
                      </div>
                      <div class="mobile-limit-list-item d-flex flex-row justify-content-between">
                        <div>Felhasznált: </div>
                        <div>{{ Number(cashFlowBasedVatLimit.used).toLocaleString("hu-HU") }}  Ft</div>
                      </div>
                    </div>
                </div>
                
              </div>
        </div>
  </b-overlay>
  </template>
  
  <script>
  import { mapGetters } from "vuex";
  import Api from "api-client/index";
  
  export default {
    name: "AnnualLimit",
  
    watch: { 
      selectedYear: function() {
        this.get58();
        this.getCashFlowBasedVatLimit();
      },
      selectedQuarter: function(newVal) {
        this.selectedQuarterData = this.data58.quarters.find(i => i.quarterOrder === newVal.value);
        this.selectedMonths = this.data58.months.filter((i) => {
          for (let j = this.selectedQuarter.value * 3; j < this.selectedQuarter.value * 3 + 3; j++) {
            if(j === i.monthOrder) {
              return true;
            }
          }
        })
      }
    },
  
    computed: {
      ...mapGetters("app", ["getActiveCompany"]),

      cashFlowBasedVatLimitProgress() {
        if (!this.cashFlowBasedVatLimit || !this.cashFlowBasedVatLimit.limit) {
          return 0;
        }

        return Math.min((this.cashFlowBasedVatLimit.used / this.cashFlowBasedVatLimit.limit) * 100, 100);
      },

      hasCashFlowBasedVatLimit() {
        if (!this.cashFlowBasedVatLimit || this.cashFlowBasedVatLimit.limit === null || this.cashFlowBasedVatLimit.limit === undefined || this.cashFlowBasedVatLimit.limit === '') {
          return false;
        }

        return Number.isFinite(Number(this.cashFlowBasedVatLimit.limit)) && Number(this.cashFlowBasedVatLimit.limit) > 0;
      },

      hasFlatRateTaxLimit() {
        if (this.data58.flatRateTaxLimit === null || this.data58.flatRateTaxLimit === undefined || this.data58.flatRateTaxLimit === '') {
          return false;
        }

        return Number.isFinite(Number(this.data58.flatRateTaxLimit));
      },
    },
  
    data() {
      return {
        errorMsg: null,
        loaded: false,
        currentYear: new Date().getFullYear(),
        yearPointer: new Date().getFullYear(),
        data58: {},
        cashFlowBasedVatLimit: null,
        companyDetails: {},
        aamCapIsHiddenData: false,
      };
    },
  
    created() {
      this.get58();
      this.getCashFlowBasedVatLimit();
      this.getCompany();
    },
  
    methods: {
      changeInterval(intervalData) {
        this.intervalButtons.forEach((button) => {
          button.active = false;
        });
  
        this.activeInterval = intervalData.value;
        intervalData.active = true;

        this.get58();
        this.getCashFlowBasedVatLimit();
        this.aamCapIsHidden(this.yearPointer);
      },
  
      pageLeft() {
        if (this.yearPointer <= 2023) {
          return;
        }

        this.yearPointer = this.yearPointer - 1;
        this.get58();
        this.getCashFlowBasedVatLimit();
        this.aamCapIsHidden(this.yearPointer);
      },
  
      pageRight() {
        if (this.currentYear === this.yearPointer ) {
          return;
        }
  
        this.yearPointer = this.yearPointer + 1;
        this.get58();
        this.getCashFlowBasedVatLimit();
        this.aamCapIsHidden(this.yearPointer);
      },
  
      calculateOffsetYearPointer(year, month, offset) {
        if (month + offset > 11) {
          return year + 1;
        }
        return year;
      },
  
      calculateOffsetMonthPointer(year, month, offset) {
        let oMonth = month + offset;
        if (oMonth > 11) {
          return oMonth - 12;
        }
        return oMonth;
      },
  
      get58(){
          Api.getPayableTaxes(this.getActiveCompany.id, this.yearPointer).then((resp) => {
          this.data58 = resp.data;
          this.loaded = true;
        }).catch((err) => {
          console.log(err);
        });
      },

      getCashFlowBasedVatLimit(){
        Api.getCashFlowBasedVatLimit(this.getActiveCompany.id, this.yearPointer).then((resp) => {
          this.cashFlowBasedVatLimit = resp.data;
        }).catch((err) => {
          console.log(err);
          this.cashFlowBasedVatLimit = null;
        });
      },

      getCompany(){
        Api.getCompany(this.getActiveCompany.id).then((resp) => {
          this.companyDetails = resp.data;
          this.loaded = true;
          this.aamCapIsHidden(this.yearPointer);
        }).catch((err) => {
          console.log(err);
        });
      },

      aamCapIsHidden(year) {
        this.aamCapIsHiddenData = !this.companyDetails.showAamCapInYears.includes(year.toString());
      },

    },
  };
  </script>
  
  <style scoped>
  .progress {
    height: 30px;
    margin-bottom: 5px;
    background-color: #b2ec5d;

  }
  
  .progress-bar {
    background-color: #b2ec5d;
  }
  
  .inform-text {
    font-family: Poppins;
    font-weight: bold;
    color: #252734;
    margin: 0 3.2rem;
  }
  
  .internal-button {
    min-width: 100%;
  }
  .card-parent {
    width: 100%;
  }

  .paging-div {
    padding: 0.6rem;
    display: flex;
    position: relative;
    flex-direction: column;
    justify-content: center;
    color: #b2ec5d;
    background-color: #252734;
    font-size: 1rem;
    border-radius: 22px;
    cursor: pointer;
  }

  .paging-div:hover {
    background-color: #b2ec5d !important;
    color: #252734 !important;
  }

  .paging-div.disabled {
    color: gray;
  }
  
 
  
  @media screen and (max-width: 1246px) {
    .inform-text {
      margin: 0;
    }
  
  
    .footnote {
      font-size: 1.1rem;
    }
  }
  
  /* Remove padding by default */
  .custom-padding {
    padding: 0.2rem; 
  }
  
  
  /* Remove padding again on lg viewport */
  @media (min-width: 992px) {
    .custom-padding {
      padding: 0;
    }
  }
  

/* Remove padding again on lg viewport */
@media (min-width: 992px) {
  .custom-padding {
    padding: 0;
  }
}

.period-label {
  font-weight: 400;
  color: rgba(0, 0, 0, 0.52);
}

.card-body {
  width: 100%;
  padding-left: 4rem !important;
  padding-right: 4rem !important;
  margin: 0 auto;
}
.title {
  font-family: Jumper;
  font-size: 2rem;
  text-align: center;
  width: 100%;
  padding: 0.25rem;
  margin: 0 0.8rem;
  margin-bottom: 0.25rem;
  border: none;
  max-width: 400px;
}

.mobile-title {
  font-family: Jumper;
  font-size: 2rem;
  text-align: center;
  width: 100%;
  padding: 0.25rem;
  margin: 0 0.8rem;
  margin-bottom: 0.25rem;
  border: none;
  max-width: 400px;
}
.mobile-limit-list-item {
  font-family: Poppins;
  font-size: 1rem;
  text-align: left;
  padding: 0.12rem;
  margin-left: 0.5rem;
}
.text-style {
  font-weight: 300;
  font-size: 32px;
  white-space: nowrap;
}
@media screen and (max-width: 1246px) {
  .text-style  {
    font-size: 16px;
  }
}
.text-style-bold {
  font-weight: 900;
  font-size: 32px;
  white-space: nowrap;
}
@media screen and (max-width: 1246px) {
  .text-style-bold  {
    font-size: 16px;
  }
}
.bottom-right-container {
  display: flex;
  align-items: center;
}
.mobile-limits {
  display: none;
}

@media screen and (max-width: 1246px) {

  .card-body {
    padding-left: 0rem !important;
    padding-right: 0rem !important;
    margin: 0 auto;
  }
  .mobile-limits {
    display: block;
  }
}

.card-container {
  width: fit-content;
  margin: 0 auto;
}

.desktop-limits {
  display: none;
}

@media screen and (min-width: 1246px) {
  .container-style {
    width: 100%;
  }
  .desktop-limits { 
    display: block;
  }
}</style>
